import React from "react";
import brandIcon from "../assets/brand-icon.png";

// Brand mark: company icon (red nested triangles on white tile)
export function BrandMark({ size = 32, className = "", testid = "brand-mark" }) {
  return (
    <img src={brandIcon} alt="Aligcus" width={size} height={size} draggable={false}
      className={`shrink-0 object-cover rounded-[22%] shadow-sm ring-1 ring-slate-200/70 dark:ring-white/10 ${className}`}
      style={{ width: size, height: size }} data-testid={testid} />
  );
}

// 品牌文字可选附加信息，显示在品牌名称后。
export function BrandLogo({ size = 36, tagline, supportingContent, dark = false, compact = false, testid = "brand-logo" }) {
  return (
    <div className="flex items-center gap-3 min-w-0" data-testid={testid}>
      <BrandMark size={size} />
      {!compact && (
        <div className="min-w-0 leading-tight">
          <div className="flex items-baseline gap-1.5 min-w-0">
            <p className={`font-display font-extrabold tracking-tight ${size >= 44 ? "text-xl" : "text-[15px]"} ${dark ? "text-white" : "text-slate-900"}`}>Aligcus</p>
            {supportingContent}
          </div>
          {tagline && <p className={`text-[11px] truncate ${dark ? "text-slate-300" : "text-slate-500"}`}>{tagline}</p>}
        </div>
      )}
    </div>
  );
}

export default BrandLogo;
